const AsanaIntegrationPage = () => import('@/pages/insights/integrations/AsanaIntegrationPage');
const TrelloIntegrationPage = () => import('@/pages/insights/integrations/TrelloIntegrationPage');
const TrelloCallbackPage = () => import('@/pages/insights/integrations/TrelloCallbackPage');
const JiraIntegrationPage = () => import('@/pages/insights/integrations/JiraIntegrationPage');

export default [
  {
    path: '/insights/integrations_management/asana',
    component: AsanaIntegrationPage,
    meta: {
      layout: 'InsightsLayout',
    },
  },
  {
    path: '/insights/integrations_management/trello',
    component: TrelloIntegrationPage,
    meta: {
      layout: 'InsightsLayout',
    },
  },
  {
    path: '/insights/integrations_management/trello/callback',
    component: TrelloCallbackPage,
    meta: {
      layout: 'InsightsLayout',
    },
  },
  {
    path: '/insights/integrations_management/jira',
    component: JiraIntegrationPage,
    meta: {
      layout: 'InsightsLayout',
    },
  },
];
